import React from 'react';

import { IonIcon, useIonActionSheet } from '@ionic/react';
import { ellipsisVertical } from 'ionicons/icons';

import Button from 'components/Button';

import { IAction, IActions } from './interfaces';
import { getActionsArray } from './utils';

const Actions: React.FC<IActions> = ({
  children,
  className,
  header,
  subHeader,
  limit,
  fill = 'clear',
  color,
  icon = ellipsisVertical,
}) => {
  const actions = getActionsArray(children);

  const [presentActionSheet] = useIonActionSheet();

  const handleClick = (action: IAction) => (e: React.MouseEvent) => {
    action?.onClick?.(e, { id: action.id });
  };

  const iconCount: number =
    limit && actions.length > limit ? limit : actions.length;

  const hiddenActions: any = actions.slice(iconCount);

  const openActionsSheet = async () => {
    await presentActionSheet({
      header: header,
      subHeader: subHeader,
      translucent: true,
      buttons: hiddenActions.map((action: IAction) => ({
        text: action.label,
        handler: handleClick(action),
        icon: action.icon,
      })),
    });
  };

  return (
    <div className={className} slot={'end'}>
      {actions.slice(0, iconCount).map((action: IAction) => {
        return (
          <Button
            key={action.id}
            fill={action.fill}
            color={action.color || 'primary'}
            onClick={handleClick(action)}
            className={
              iconCount === 1 && !hiddenActions.length
                ? 'ion-padding-horizontal'
                : undefined
            }
          >
            {action.icon ? <IonIcon icon={action.icon} /> : null}
            {action.label}
          </Button>
        );
      })}
      {hiddenActions.length ? (
        <Button fill={fill} color={color} onClick={openActionsSheet}>
          <IonIcon icon={icon} />
        </Button>
      ) : null}
    </div>
  );
};

export default Actions;
